import React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button } from 'reactstrap';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { getUser, userLogout } from '../store/actions/authActions'
import Signout from './auth/Signout'
import Dropdown from 'react-dropdown';
import { FaInfoCircle } from "react-icons/fa";
import Player from "./player"

export default class Footer extends React.Component {


    getFooter() {
        let idToken = localStorage.getItem('idToken');
        if (idToken) {
            return (

                <footer className="page-footer font-small">
                   
                   

                </footer>

            );
        } else {
            return (<footer className="page-footer font-small">

                <div className="footer-copyright text-center py-3">
                   <b></b>
                </div>

            </footer>);
        }
    }
    render() {

        return (

           <div> { this.getFooter() }</div>
     
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js